export default __webpack_public_path__ + "a0ebca7436df7b7dc5e0dffa8926b8b4.png";